
import { call } from 'redux-saga/effects';

import { getViewInfos } from '~src/app/sagas/spaces/SpacesSagaHelpers';
import { ViewCard } from '~src/app/spaces/CardView/ViewCard';
import { SpacesSiteUrls } from '~src/app/spaces/SpacesSiteUrls';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { MixedContentItemDefinition, SpaceDefinition, ContentTypeFilterClause } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { ViewContentType } from '~src/ts/models/ContentTypes';
import { IContentInfo } from '~src/ts/models/IContentInfo';
import { Views } from '~src/views/resources/Views';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const ViewDefinition: MixedContentItemDefinition & SpaceDefinition<'view'> = {
  itemType: 'view',
  contentType: 'view',
  singularName: Messages.view,
  pluralName: Messages.views,
  emptyStateMessage: Messages.viewsEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Views,
  contentFilterKeys: ViewContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: ViewCard,
  listViewIconUrl: imgPath('view_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['view']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.redirectToViewUrl(contentId),
  getBasicQuery: () => {
    return Views.all().withExtraParams(ViewContentType.extraQueryParams);
  },
  fieldValueResourceType: 'view',
  getContentInfo: (contentList: IContentInfo[]) => call(getViewInfos, contentList),
  headerIconPath: undefined,
  supportedDisplayModes: ['list', 'thumbnail'],
};
